/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */

import React from 'react';
import ReactDOM from 'react-dom';
import {withRouter} from 'react-router';

import {Modal, Glyphicon, Button, Form, FormGroup, InputGroup, FormControl} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import APIActions from '../../../actions/apiActions';
import JobStore from '../../../stores/JobStore';
import UserStore from '../../../stores/UserStore';


class JobSelect extends React.Component {
    constructor(props) {
        console.log("[JobSelect] - initialisation");

        super(props);
        this._onJobChange = this._onJobChange.bind(this);
        this.onJobSelectRow = this.onJobSelectRow.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.search = this.search.bind(this);
        this.selectJob = this.selectJob.bind(this);

        this.state = {
            searchText : "",
            selected : {},
            // existingSelection : {},
            jobs: []
        }
    }

    componentDidMount() {
        console.log("[JobSelect] - componentDidMount");
        JobStore.addChangeListener(this._onJobChange) ;
    }

    componentWillUnmount() {
        console.log("[JobSelect] - componentWillUnmount");
        JobStore.removeChangeListener(this._onJobChange);
    }

    _onJobChange() {
        var jobs = JobStore.jobs() ;
        console.log("JOBS=", jobs) ;
        var s = this.state ;
        s.jobs = JobStore.jobs() ;
        this.setState(s);
    }

    onJobSelectRow(row,isSelected,e) {
        var sel = this.state.selected ;
        if (isSelected) {
            sel[row.jobId] = row ;
        }
        else {
            sel[row.jobId] = undefined ;
        }

        this.setState({selected : sel});
        return true ;
    }


    selectJob() {
        var jobs = [];
        var keys = Object.keys(this.state.selected) ;
        for (var ki in keys) {
            var key = keys[ki];
            jobs.push(this.state.selected[key]);
        }

        if (this.props.onSelect) {
            this.props.onSelect(jobs);            
        }
    }

    handleChange(e) {
        console.log("[EVENT] - pressed search option");
        e.preventDefault();

        var s = this.state ;
        s.searchText = e.target.value ;
        this.setState(s);
    }

    search() {
        var text = ReactDOM.findDOMNode(this.refs.searchtext).value;
        console.log("SEARCH FOR: " + text);
        var st = text === "" ? "*" : text;
        let user = UserStore.user() ;
        if (user) {
            APIActions.searchJobs(st, user.user.username) ;
        }
    }

    cellButton(cell, row, enumObject, rowIndex) {
        if (!cell) {
            return <Glyphicon glyph="minus"/>            
        }
        else {
            return <Glyphicon bsStyle="success" glyph="ok-sign"/>            
        }
    }

    render() {
        const selectRowProp = {
            mode: 'checkbox',
            bgColor: 'lightblue',
            clickToSelect: true,
            onSelect: this.onJobSelectRow
        };

        const options = {
            sortName: 'jobnum',  // default sort column name
            sortOrder: 'asc',  // default sort order
            sizePerPage: 10,
            hideSizePerPage: true,
        };

        var self = this ;
        return (
            <Modal  show={true} onHide={this.props.onSelectCancelled} dialogClassName="select-job-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Select Jobs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form horizontal onSubmit={event => event.preventDefault()} width="400px">
                        <FormGroup controlId="formGroupSearchId" >
                            <InputGroup>
                                <FormControl type="text" placeholder="enter search text" ref="searchtext" value={this.state.searchText} onChange={this.handleChange}/>
                                <InputGroup.Button>
                                    <Button onClick={this.search}><Glyphicon glyph="search" /></Button>
                                </InputGroup.Button>
                            </InputGroup>
                        </FormGroup>
                    </Form>
                    <br/>
                    <p>Select which jobs you wish to allocate to the dealer by toggling the checkbox column and then pressing the Select button. Jobs already allocated to a dealer are indicated by a tick in the Assigned column.</p>
                    <br/>

                    <BootstrapTable data={ this.state.jobs }
                        selectRow={ selectRowProp }
                        options={ options }
                        hover focus search pagination
                        tableContainerClass='orbit-table-container'>

                        <TableHeaderColumn dataField='jobId' hidden={true}  isKey >ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='jobnum' >Job Num</TableHeaderColumn>
                        <TableHeaderColumn dataField='displayName' >Name</TableHeaderColumn>
                        <TableHeaderColumn dataField='client' >Client</TableHeaderColumn>
                        <TableHeaderColumn dataField='dealerId' width="90px" dataFormat={this.cellButton.bind(this)} >Assigned</TableHeaderColumn>
                    </BootstrapTable>
                    <br/>

                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="danger" onClick={this.props.onSelectCancelled}>Cancel</Button>
                    <Button bsStyle="success" onClick={this.selectJob}>Select</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(JobSelect);



// WEBPACK FOOTER //
// ./src/app/components/admin/dealers/jobSelect.js